// Docs are here: https://stimulus.hotwired.dev/
import {Application} from '@hotwired/stimulus'

const stimulus = Application.start()

// Dynamically import and register all controllers
// This assumes controllers are in app/javascript/hotwire/controllers
// and follow the naming convention of index.js in each controller directory
const context = require.context('../hotwire/controllers', true, /index\.js$/)
const registeredControllers = new Set() // Track registered controllers

context.keys().forEach((key) => {
  // Extract just the final directory name before index.js
  const parts = key.split('/')
  const controllerName = parts[parts.length - 2].replace(/_/g, '-')

  // Prevent duplicate registrations
  if (!registeredControllers.has(controllerName)) {
    const controller = context(key).default
    stimulus.register(controllerName, controller)
    registeredControllers.add(controllerName)
  }
})

export default stimulus
